import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  ViewEncapsulation
} from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { CheckIcon } from 'primeng/icons';
import { Toast } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { PrimeTemplate } from 'primeng/api';
import { AppUpdaterService } from './common/services/app-updater.service';
import { LoaderDialogComponent } from './common/providers/load-state-provider/components/loader-dialog/loader-dialog.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    RouterLink,
    Toast,
    CheckIcon,
    PrimeTemplate,
    ConfirmDialogModule,
    DialogModule,
    ButtonModule,
    LoaderDialogComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class App {
  // although not used anywhere else,
  // keep this service injected to enable cookie consent functionality
  private consentCookies = inject(NgcCookieConsentService);
  private appUpdater = inject(AppUpdaterService);
  protected readonly hasNewVersion = this.appUpdater.updateDialogVisible;
  protected readonly title = signal('velocity-markets-ui');
  protected closeDialog = this.appUpdater.closeDialog;
  protected reloadPage = this.appUpdater.installUpdate;
}
